import { Component, OnInit, ViewChild } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { TipoSolicitudService } from '../../infrastructure/services/tiposolicitud.service';
import { BuscadorPipe } from '../../helpers/pipes/buscador.pipe';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ListadoSolicitudDisponibleComponent } from 'app/helpers/components/aviableSolicitudeList/aviableSolicitudeList.component';
import { ItemSolicitudesDisponiblesListado } from 'app/helpers/components/itemClasses/itemListadoSolicitudesDisponibles.class';

@Component({
  templateUrl: './solicitud.component.html',
  providers: [TipoSolicitudService, BuscadorPipe]
})
export class SolicitudComponent implements OnInit {
  @ViewChild('listadoComponent') listadoComponent: ListadoSolicitudDisponibleComponent;
  solicitudesDisponibles: Observable<ItemSolicitudesDisponiblesListado[]>;
  codSistema;
  codNegocio;
  codProducto;

  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private solicitudService: TipoSolicitudService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];


    this.solicitudesDisponibles = forkJoin(
        this.solicitudService.getDisponiblesForList(),
        this.solicitudService.getByLevel(this.codSistema, this.codNegocio, this.codProducto)
      )
      .map(([solDisponibles, solEnNivel]) => {
        solDisponibles.forEach(solicitud => {
          const utilizadoEnNivel = solEnNivel.find(item => item.id === solicitud.Codigo);
          solicitud.UtilizadoEnNivel = !!utilizadoEnNivel;
        });
        return solDisponibles;
      });
    });
  }

  toogleStatus(item: ItemSolicitudesDisponiblesListado) {
    this.solicitudService
      .insertOrDeleteLevel(item.Codigo, this.codSistema, this.codNegocio, this.codProducto)
      .then(res => {
        if (res !== null && res !== '' && res !== undefined) {
          this.listadoComponent.toogleItem(item);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/solicitud/solicitud.component.ts